<template>
  <div class="pa-20" ref="pagePdv" v-if="enseigne">
    <div class="level is-mobile">
      <div class="level-left">
        <div class="level-item pointer" @click="$emit('back')" v-if="typeClient === 'Groupe'">
          <b-icon icon="chevron-left"></b-icon>
        </div>
        <div class="level-item has-text-grid-1 has-text-weight-bold is-size-18px">
          <p class="has-text-left">Points de vente associés à l’enseigne {{enseigne.libelle}}</p>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <b-notification type="is-white" :closable="false" class="pa-10">
            <p class="is-size-14px has-text-default">
              Total enseigne
              <strong class="pa-10">{{formatNombre(totalRecomEnseigne)}}</strong> HT
            </p>
          </b-notification>
        </div>
        <div class="level-item">
          <b-button type="is-color-button" class="is-size-14px has-text-weight-bold"
            @click="modalIsActive = !modalIsActive">
            Détail
          </b-button>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-content pa-10">
        <div class="media">
          <div class="media-left logo">
            <img class="logo" :src="getImgPdv(enseigne.logoUrl)">
          </div>
          <div class="media-content pa-10">
            <div class="content">
              <p class="has-text-grid-1 is-size-7 mb-4 has-text-weight-bold">
                  {{enseigne.libelle}}
              </p>
              <p class="has-text-default is-size-14px has-text-weight-bold">
                {{nbreRecom(enseigne.id)}} recommandations
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="columns is-multiline is-12 mt-5" v-if="pdVentes.length">
      <div class="column is-6 pa-5" v-for="(pdv, i) in pdVentes" :key="i">
        <div class="card pointer" @click="accessRecom(pdv.previewLink)">
          <div class="card-content pa-10">
            <div class="content">
              <div class="media">
                <div class="media-left logo">
                  <img class="logo" :src="getImgPdv(pdv.srcImg)">
                </div>
                <div class="media-content pa-10">
                  <div class="content">
                    <p class="has-text-grid-1 is-size-7 mb-4 has-text-weight-bold">
                      {{pdv.libelle}}
                    </p>
                    <p class="has-text-default is-size-10px mb-4">
                      {{pdv.adresse.libelle}}
                    </p>
                    <p class="has-text-default is-size-10px">
                      <strong>{{pdv.nbrePanneaux}}</strong> panneaux (<strong>{{pdv.nbrePanneauxNew}}</strong> nouveaux, <strong>{{pdv.nbrePanneauxOld}}</strong> déjà sous contrat)
                    </p>
                  </div>
                </div>
                <div class="media-right pa-10">
                  <p class="is-size-14px">
                    <strong>{{formatNombre(pdv.montant)}}</strong> HT
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ModalCumulregies
    :modal-is-active="modalIsActive"
    :recoms="recoms"
    :type="type"
    :enseignes="[{
      libelle : enseigne.libelle,
      id : enseigne.id,
    }]"
    @modalIsClose="modalIsActive = $event"/>
  </div>
</template>

<script>
import ModalCumulregies from '@/components/portailGroupe/modalCumulRegies';
import { formatNombre, getImgPdv } from '@/services/general/general';

export default {
  components: {
    ModalCumulregies,
  },
  props: {
    recoms: Array,
    enseignes: Array,
    pdVentes: Array,
    typeClient: String,
  },
  data() {
    return {
      modalIsActive: false,
      recomsEnseigne: [],
      type: 'enseigne',
      logoClient: {},
    };
  },
  computed: {
    totalRecomEnseigne() {
      if (!this.pdVentes.length) return 0;
      return this.pdVentes
        .map(pdv => pdv.montant)
        .reduce((a, b) => a + b);
    },
    enseigne() {
      return this.enseignes ? this.enseignes[0] : null;
    }
  },
  methods: {
    nbreRecom(id)  {
      const recom = this.recoms.filter(recom => recom.idEnseigne === id);
      return recom.length;
    },
    accessRecom(lien){
      window.open(lien);
    },
    formatNombre(val) {
      return formatNombre(val);
    },
    getImgPdv(url) {
      return getImgPdv(url);
    },
  }
}
</script>

<style>

</style>